import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetSevaCategoriesQuery, useGetSevasByCategoryQuery } from '../redux/api/sevaApi';
// import SevaCart from '../components/SevaCart'; // Removing SevaCart as per requirement

const GuruSevaBooking = () => {
  const navigate = useNavigate();
  const { data: categoriesData } = useGetSevaCategoriesQuery();
  const [guruSevaCategoryId, setGuruSevaCategoryId] = useState(null);

  // Find Guru Seva category ID based on Master Category Name
  useEffect(() => {
    if (categoriesData && categoriesData.data) {
      // We want to find the specific sub-category that the user considers "Guru Seva" 
      // OR if there are multiple, we might need a different UI.
      // The current UI assumes a single "Guru Seva" page. 
      // Let's assume there is a sub-category named "Guru Seva" under Master Category "Guru Seva" OR just pick the first one?
      // User request: "fetch data of sevas list where master category = "Guru Seva" and its sub category name"

      // Let's find the first sub-category under Master Category "Guru Seva"
      const category = categoriesData.data.find(c => c.master_category_id && c.master_category_id.name === "Guru Seva");

      if (category) {
        setGuruSevaCategoryId(category._id);
      }
    }
  }, [categoriesData]);

  const { data: sevasData, isLoading, isError } = useGetSevasByCategoryQuery(guruSevaCategoryId, {
    skip: !guruSevaCategoryId
  });



  const [selectedDate, setSelectedDate] = useState(() => {
    return sessionStorage.getItem('selected_seva_date') || new Date().toISOString().split('T')[0];
  });

  useEffect(() => {
    sessionStorage.setItem('selected_seva_date', selectedDate);
  }, [selectedDate]);

  const todayStr = new Date().toISOString().split('T')[0];
  const maxDate = new Date();
  maxDate.setMonth(maxDate.getMonth() + 3);
  const maxDateStr = maxDate.toISOString().split('T')[0];

  // Cart Logic
  const [cartItems, setCartItems] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem('cart_guru')) || [];
    } catch (e) {
      console.error("Failed to parse cart_guru", e);
      return [];
    }
  });

  useEffect(() => {
    sessionStorage.setItem('cart_guru', JSON.stringify(cartItems));
  }, [cartItems]);

  const handleToggleSeva = (seva) => {
    setCartItems((prevItems) => {
      const exists = prevItems.some((item) => item._id === seva._id);
      if (exists) {
        return prevItems.filter((item) => item._id !== seva._id);
      } else {
        return [...prevItems, { ...seva, god_name: "Guru Seva" }];
      }
    });
  };

  return (
    <>
      <div className="my-account th-checkout-wrapper space-extra-bottom">
        <div className="container">
          <div className="title-area text-center">
            <span className="sub-title-img">
              <img src="assets/img/theme-img/title_shape.svg" alt="shape" />
            </span>
            <h2 className="sec-title text-anime-style-3">Guru Seva</h2>
            <span className="title-img">
              <img src="assets/img/theme-img/title_shape2.svg" alt="shape" />
            </span>
          </div>
          <div className="row">
            <div className="col-12">
              <section className="seva-section">
                <div>
                  <div className="guru-seva mt-5 row justify-content-center">
                    <div className="col-lg-7">
                      <div>
                        <p className="fs-4 text-center">
                          त्यागमूर्तिं तपोनिष्ठं शारदार्चनतत्परम् ।
                          <br />
                          सच्चिदानन्दयोगीन्द्रं प्रत्यहं प्रणमाम्यहम् ॥
                        </p>
                        <p className="text-center">
                          <b>Meaning:</b>
                          <br />
                          “I bow down every day to that great Yogi, who is the
                          embodiment of renunciation, steadfast in austerity,
                          <br />
                          deeply devoted to the worship of Goddess Śāradā, and
                          established in the supreme state of Sat–Cit–Ānanda
                          (Existence–Consciousness–Bliss).”
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 mt-5 mt-lg-0">
                      <img style={{ width: '100%', height: 'auto', borderRadius: '16px' }} src="assets/img/seva/guru.jpg"
                        alt="..." />
                    </div>

                    <div className="col-lg-6 col-md-8 col-sm-10 mt-5">
                      <div className="p-4 rounded shadow-sm" style={{ border: '1px solid #ddd', backgroundColor: '#fff' }}>
                        <h4 className="mb-3" style={{ color: '#C20000', fontSize: '1.2rem' }}>
                          <i className="fa-regular fa-calendar-days me-2"></i> Select Seva Date
                        </h4>
                        <div className="form-group">
                          <label className="mb-2" style={{ fontWeight: '500' }}>Choose Date for Seva Performance:</label>
                          <input
                            type="date"
                            className="form-control"
                            value={selectedDate}
                            min={todayStr}
                            max={maxDateStr}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            style={{
                              padding: '12px',
                              borderRadius: '8px',
                              border: '2px solid #C20000',
                              fontSize: '1rem',
                              fontWeight: 'bold'
                            }}
                          />
                          <small className="text-muted mt-2 d-block">
                            * Seva can be booked for today or up to 3 months in advance.
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 mt-5">
                      {isLoading && <div className="text-center">Loading sevas...</div>}
                      {isError && <div className="text-center text-danger">Error loading sevas</div>}

                      {!isLoading && !isError && sevasData && sevasData.data && (
                        <table style={{ width: '100%', color: '#000' }}>
                          <thead>
                            <tr>
                              <th>Seva Name</th>
                              <th>Amount</th>
                              <th>Book Seva</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sevasData.data.map((seva) => {
                              const isChecked = cartItems.some(item => item._id === seva._id);
                              return (
                                <tr key={seva._id}>
                                  <td>{seva.seva_name}</td>
                                  <td>₹{seva.seva_amount}</td>
                                  <td>
                                    <div>
                                      <input
                                        className="style2"
                                        type="checkbox"
                                        id={`seva-${seva._id}`}
                                        checked={isChecked}
                                        onChange={() => handleToggleSeva(seva)}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      )}
                      {!isLoading && !guruSevaCategoryId && categoriesData && (
                        <div className="text-center mt-3">Guru Seva category not found.</div>
                      )}
                    </div>
                  </div>
                </div>
              </section>

              {cartItems.length > 0 && (
                <div className="fixed-bottom-footer" style={{
                  position: 'fixed',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  backgroundColor: '#7a0000',
                  boxShadow: '0 -4px 15px rgba(0,0,0,0.3)',
                  padding: '15px 20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  zIndex: 1000
                }}>
                  <div className="footer-content" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    alignItems: 'center'
                  }}>

                    <div className="footer-total" style={{ fontSize: '1.4rem', fontWeight: 'bold', color: '#ffffff' }}>
                      Total: <span style={{ color: '#FFD700', fontWeight: '800', fontSize: '1.6rem' }}>₹{cartItems.reduce((acc, item) => acc + Number(item.seva_amount), 0)}/-</span>
                    </div>
                    <button
                      className="btn-next"
                      onClick={() => navigate('/seva-summary', { state: { cartItems, sevaDate: selectedDate, is_guru_seva: true } })}
                      style={{
                        backgroundColor: '#C20000',
                        color: 'white',
                        border: 'none',
                        padding: '10px 30px',
                        borderRadius: '5px',
                        fontWeight: 'bold',
                        cursor: 'pointer'
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuruSevaBooking;
